import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { cartService } from '../services/cartService';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState([]);
    const [cartCount, setCartCount] = useState(0);

    // 👉 Dùng useCallback để hàm fetchCart ổn định về định danh (reference)
    // Giúp các component con khi đưa fetchCart vào useEffect dependency không bị loop
    const fetchCart = useCallback(async () => {
        const token = localStorage.getItem('access_token');
        if (!token) {
            setCartItems([]);
            setCartCount(0);
            return;
        }
        try {
            const res = await cartService.getCart();
            const items = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
            setCartItems(items);
            // Tính tổng số lượng
            const total = items.reduce((sum, item) => sum + item.quantity, 0);
            setCartCount(total);
        } catch (error) {
            // Nếu lỗi 401 (hết hạn token) thì clear giỏ hàng luôn
            if (error.response?.status === 401) {
                setCartItems([]);
                setCartCount(0);
            }
            console.error("Lỗi lấy giỏ hàng", error);
        }
    }, []);

    // 👉 Tự động load giỏ hàng khi mới vào web
    useEffect(() => {
        fetchCart();
    }, [fetchCart]);

    // 👉 THÊM: Lắng nghe sự kiện đăng nhập/đăng xuất toàn cục
    // Khi bạn thực hiện Login thành công, hãy gọi fetchCart() hoặc bắn 1 event
    useEffect(() => {
        const handleAuthChange = () => fetchCart();
        
        // Lắng nghe sự kiện tùy chỉnh nếu bạn có bắn từ trang Login/Logout
        window.addEventListener('authChange', handleAuthChange);
        window.addEventListener('storage', handleAuthChange); // Theo dõi thay đổi localStorage từ tab khác

        return () => {
            window.removeEventListener('authChange', handleAuthChange);
            window.removeEventListener('storage', handleAuthChange);
        };
    }, [fetchCart]);

    return (
        <CartContext.Provider value={{ cartItems, cartCount, fetchCart, setCartItems, setCartCount }}>
            {children}
        </CartContext.Provider>
    );
};